export default __webpack_public_path__ + "static/island-life-desktop-bb63b4822147b246f73c38e0ac7b1d67.webp";